import { createContext } from 'react'

const alwaysFalse = (_carouselId: string, _category: string) => false

interface LuxPlusLandingFilterRegistryContextValue {
  hasFilterCategory: (carouselId: string, category: string) => boolean
}

const LuxPlusLandingFilterRegistryContext = createContext<LuxPlusLandingFilterRegistryContextValue>({
  hasFilterCategory: alwaysFalse,
})

export type { LuxPlusLandingFilterRegistryContextValue }
export default LuxPlusLandingFilterRegistryContext
